import BaseService from "../BaseService";
import { composeMixins } from "../services.utils";
import { RainHistoryServiceMixin } from "./rainHistoryService";

export class RainService extends composeMixins(RainHistoryServiceMixin)(
  BaseService
) {}
